<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">

      <v-container fluid class="body_content">
        <v-alert text type="info">
          <small class="text-info">
            Informação atualizada até {{ returnDateNow() }}
          </small>
        </v-alert>

        <h2>Parcerias Interinstitucionais</h2>

        <v-row>
          <v-col cols="12" md="2">
            <v-text-field
                label="Número da Parceria"
                v-model="filtro.numeroParceria"
                v-on:keyup.enter="buscarConvenios()"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
                type="number"
                label="Ano da Parceria"
                v-model="filtro.anoParceria"
                v-on:keyup.enter="buscarConvenios()"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
                label="Parceiro"
                v-model="filtro.convenente"
                v-on:keyup.enter="buscarConvenios()"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
                label="Responsável"
                v-model="filtro.responsavel"
                v-on:keyup.enter="buscarConvenios()"
            />
          </v-col>

          <v-col md="3" cols="12" style="margin-top: 1.1%">
            <v-select
                solo
                dense
                :disabled="loadingSelect"
                :loading="loadingSelect"
                v-model="tipoConvenio"
                :items="tiposC"
                item-text="descricao"
                item-value="tipoConvenioId"
                label="Tipo de Convênio"
                return-object
                @change="atualizarFiltro"
            ></v-select>
          </v-col>
          <span class="mt-8" style="color: red">*</span>

          <v-col cols="12" md="1" style="margin-top: 1.8%">
            <v-btn
                style
                color="primary"
                small
                depressed
                :loading="loadingBusca"
                :disabled="loadingBusca"
                @click="buscarConvenios()"
            >
              <v-icon small>fa-search</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="1" style="margin-top: 1.8%">
            <v-btn
                style
                color="primary"
                small
                depressed
                @click="limparFiltros()"
            >
              <v-icon small>fa-eraser</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="lista.length == 0"
              small
              color="primary"
              @click="baixarDados()"
          >
            <v-icon class="mr-2" small>fa-download</v-icon>
            Baixar Dados
          </v-btn>
          <v-btn
              v-if="semResultado"
              :disabled="!filtro.anoParceria"
              small
              color="warning"
              class="ml-2"
              @click="baixarDeclaracao()"
          >
            <v-icon class="mr-2" small>fa-file-pdf</v-icon>
            Declaração de Ausência
          </v-btn>
        </v-row>

        <v-alert
            v-if="semResultado"
            type="warning"
            outlined
            dense
            class="mt-4"
        >
          <span v-if="anoBuscado">
            Para o exercício <strong>{{ anoBuscado }}</strong>, você pode baixar a
            <strong>Declaração de Ausência de Informação</strong> clicando no botão ao lado.
          </span>
          <span v-else>Nenhum resultado encontrado para o filtro informado.</span>
        </v-alert>

        <v-alert
            v-if="erroServico"
            type="error"
            outlined
            dense
            class="mt-4"
        >
          Não foi possível consultar as parcerias no momento. Tente novamente em instantes.
        </v-alert>

        <v-row style="margin-top: 10px" justify="center">
          <v-col cols="12" md="12">
            <template>
              <v-data-table
                  @click:row="abrirDialog"
                  :headers="headers"
                  :items="lista"
                  :items-per-page="10"
                  :loading="loadingBusca"
                  class="elevation-1 mytable"
                  no-results-text="A busca não trouxe resultados."
                  :no-data-text="textoSemDados"
              >
                <template v-slot:loading>
                  <LoadingSpinner text="Carregando convênios... aguarde." />
                </template>
                <template v-slot:item.dataAssinaturaFormatada="{ item }">
                <span>
                  {{
                    item.dataAssinatura
                        ? $moment(item.dataAssinatura).format("DD/MM/YYYY")
                        : "Não Informado"
                  }}
                </span>
                </template>
                <template v-slot:item.actions="{ }">
                  <v-icon class="icon-view">mdi-eye</v-icon>
                </template>
              </v-data-table>
            </template>

            <v-dialog v-model="dialog" max-width="700px">
              <v-card>
                <v-card-title class="grey lighten-2"
                >Convênios TCE-MA
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col v-if="convenio.numeroProcesso" cols="12" md="4">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Processo"
                            v-model="convenio.numeroAnoProcesso"
                        ></v-text-field>
                      </v-col>

                      <v-col v-else cols="12" md="3">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Processo"
                            value="Não Informado"
                        />
                      </v-col>

                      <v-col cols="12" md="8">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Tipo"
                            v-model="convenio.tipoConvenio.descricao"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Número/Ano"
                            v-model="convenio.numeroAnoParceria"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Vigência"
                            v-model="convenio.vigenciaParceria"
                        ></v-text-field>
                      </v-col>

                      <v-col md="4">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            type="date"
                            label="Assinatura"
                            v-model="convenio.dataAssinatura"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Parceiro"
                            v-model="convenio.convenente"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="10">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Responsável"
                            v-model="convenio.responsavel"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            class="font-weight-black"
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="objeto"
                            label="Objeto"
                            v-model="convenio.objeto"
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="download"
                            :value="convenio.arquivo.substring(0, 35) + '...'"
                        />
                      </v-col>
                      <v-col>
                        <v-tooltip bottom v-if="convenio.arquivo">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="download()"
                                dark
                                color="#606060"
                                depressed
                                class="rounded-pill mt-5 mr-2"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                              <v-icon class="">fas fa-file-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Download do arquivo</span></v-tooltip
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false"
                  >Fechar
                  </v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import convenioService from "@/service/ConvenioService";
import csvUtils from "@/service/CsvUtils";
import Convenio from "@/model/convenio";

export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      lista: [],
      semResultado: false,
      erroServico: false,
      anoBuscado: null, // ano da última busca (não muda enquanto o usuário digita outro)
      loadingBusca: false,
      convenio: Convenio(),
      headers: [
        {text: "Tipo", value: "tipoConvenio.descricao", sortable: false},
        {text: "Número/Ano", value: "numeroAnoParceria", sortable: false},
        {text: "Parceiro", value: "convenente", sortable: false},
        {text: "Responsável", value: "responsavel", sortable: false},
        {
          text: "Data da Assinatura",
          value: "dataAssinaturaFormatada",
          sortable: false,
        },
        {text: "Detalhes", value: "actions"},
      ],
      filtro: {
        numeroProcesso: null,
        anoProcesso: null,
        numeroParceria: null,
        anoParceria: null,
        tipoConvenioId: null,
        convenente: null,
        responsavel: null,
      },
      tipoConvenio: {},
      tiposC: [],
      loadingSelect: true,
    };
  },
  computed: {
    // texto exibido dentro da tabela quando não há linhas
    textoSemDados() {
      if (this.erroServico) {
        return "Não foi possível carregar os dados.";
      }
      if (this.semResultado && this.anoBuscado) {
        return `Nenhum resultado para o ano de ${this.anoBuscado}.`;
      }
      return "A busca não trouxe resultados.";
    },
  },
  methods: {
    returnDateNow() {
      return this.$moment().format("DD/MM/YYYY");
    },
    atualizarFiltro() {
      this.filtro.tipoConvenioId = this.tipoConvenio.tipoConvenioId;
    },

    buscarTiposConvenio() {
      convenioService.findTiposConvenio().then((res) => {
        this.tiposC = res || [];
        let t = {tipoConvenioId: null, descricao: "Todos"}
        this.tiposC.unshift(t);
      }).finally(() => {
        this.loadingSelect = false;
      });
    },

    buscarConvenios() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.semResultado = false;
      this.erroServico = false;
      this.anoBuscado = this.filtro.anoParceria;
      this.loadingBusca = true;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner

      const semFiltros =
          this.filtro.anoProcesso == null &&
          this.filtro.anoParceria == null &&
          this.filtro.convenente == null &&
          this.filtro.responsavel == null &&
          this.filtro.numeroProcesso == null &&
          this.filtro.numeroParceria == null &&
          (this.filtro.tipoConvenioId == null);

      const promise = semFiltros
          ? convenioService.findAll()
          : convenioService.buscarConvenioFiltro(this.filtro);

      promise
          .then((res) => {
            this.lista = res || [];
            if (this.lista.length === 0) {
              this.semResultado = true;
            }
          })
          .catch(() => {
            // falha real (rede/API fora do ar): aviso de indisponibilidade, não "sem resultado"
            this.lista = [];
            this.erroServico = true;
          })
          .finally(() => {
            this.loadingBusca = false;
          });
    },

    limparFiltros() {
      for (let i in this.filtro) {
        this.filtro[i] = null;
      }
      this.buscarConvenios()
    },

    baixarDados() {
      csvUtils.exportCsv(this.lista)
    },

    baixarDeclaracao() {
      const exercicio = this.filtro.anoParceria;
      if (!exercicio) {
        alert('Informe o Ano da Parceria para baixar a declaração de ausência.');
        return;
      }
      convenioService.downloadDeclaracaoPdf(exercicio);
    },

    download() {
      convenioService.downloadArquivo(this.convenio.convenioId)
    },
    abrirDialog(item) {
      Object.assign(this.convenio, item);
      this.dialog = true;
    },
  },
  created() {
    this.buscarTiposConvenio();
    this.buscarConvenios(); // carga inicial: mesmo fluxo da busca (spinner + tratamento de erro)
  },
};
</script>

<style scoped>
.body_content {
  margin: auto;
  padding: 2rem 5rem;
}

.text-info {
  color: #000000;
}
</style>